import { forwardRef } from "react";
import { NavLink } from "react-router-dom";

const iconSize = 22;

const BottomNav = forwardRef<HTMLDivElement, { hidden?: boolean }>(
  ({ hidden }, ref) => {
    const baseBtn: React.CSSProperties = {
      flex: 1,
      textAlign: "center",
      textDecoration: "none",
      color: "#374151",
      fontSize: 12,
      padding: "8px 6px",
      borderRadius: 10,
      lineHeight: 1.1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4
    };

    const wrap: React.CSSProperties = {
      position: "fixed",
      left: 0, right: 0, bottom: 0,
      zIndex: 1000,
      transform: hidden ? "translateY(120%)" : "translateY(0)",
      transition: "transform .25s ease",
      // Blur + safe area
      background: "rgba(255,255,255,0.92)",
      backdropFilter: "saturate(180%) blur(10px)",
      borderTop: "1px solid #e5e7eb",
      padding: "8px max(10px, env(safe-area-inset-left)) calc(8px + env(safe-area-inset-bottom)) max(10px, env(safe-area-inset-right))"
    };

    // Simple SVG icons
    const Icon = ({ d }: { d: string }) => (
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d={d} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );

    return (
      <div ref={ref} style={wrap}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          gap: 8,
          alignItems: "end",
          width: "min(720px, 100%)",
          margin: "0 auto"
        }}>
          {/* Profil - left (less frequent, full width 1fr) */}
          <NavLink
            to="/profile"
            style={({isActive}) => ({
              ...baseBtn,
              color: isActive ? "#667eea" : "#374151",
              fontWeight: isActive ? 600 : 400
            })}
            aria-label="Profil"
          >
            <Icon d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-4 0-7 2-7 4v2h14v-2c0-2-3-4-7-4z" />
            <div>Profil</div>
          </NavLink>

          {/* Pridať - center (primary CTA, elevated) */}
          <NavLink
            to="/add"
            aria-label="Pridať bloček"
            onClick={() => {
              // Emit custom event to reset AddReceiptPage to scanner view
              window.dispatchEvent(new CustomEvent('resetToScanner'));
            }}
            style={{
              justifySelf: "center",
              alignSelf: "center",
              textDecoration: "none",
              background: "#667eea",
              color: "#fff",
              borderRadius: 14,
              padding: "12px 20px",
              fontWeight: 700,
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              boxShadow: "0 6px 16px rgba(102,126,234,.35)",
              border: "2px solid #5a67d8",
              fontSize: 14
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              <path d="M12 5v14M5 12h14" strokeLinecap="round"/>
            </svg>
            Pridať
          </NavLink>

          {/* Right side - Bločky + Analýzy (thumb-optimized, split 1fr) */}
          <div style={{ display: "flex", gap: 4 }}>
            <NavLink
              to="/receipts"
              style={({isActive}) => ({
                ...baseBtn,
                color: isActive ? "#667eea" : "#374151",
                fontWeight: isActive ? 600 : 400
              })}
              aria-label="Bločky"
            >
              <Icon d="M8 4h8v16H8z M8 9h8 M8 13h8" />
              <div>Bločky</div>
            </NavLink>

            <NavLink
              to="/analytics"
              style={({isActive}) => ({
                ...baseBtn,
                color: isActive ? "#667eea" : "#374151",
                fontWeight: isActive ? 600 : 400
              })}
              aria-label="Analýzy"
            >
              <Icon d="M18 20V10 M12 20V4 M6 20v-6" />
              <div>Analýzy</div>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
);

export default BottomNav;
